import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CtaLink from 'components/essentials/Cta/CtaLink';
import TextPlaceholder from 'components/consumer/TextPlaceholder';

const ItemPlaceholder = () => (
  <span>
    <TextPlaceholder className="w-1/2 md:!w-[50px] !inline-flex !mt-1 md:!mt-0" />
  </span>
);

const BreadcrumbItem = props => {
  const { link, loading = false, isLast = false, backIcon = false } = props;

  return (
    <li
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
      className="inline-block before:relative before:top-px before:left-0 before:text-xs before:p-2 before:text-gray-light1 before:animate-fade-in-ease before:content-['>'] first:before:hidden"
    >
      {isLast ? (
        <span itemScope itemType="https://schema.org/Thing" itemProp="item">
          {loading ? (
            <ItemPlaceholder />
          ) : (
            <span itemProp="name" className="text-xs">
              {props.label}
            </span>
          )}
        </span>
      ) : loading ? (
        <div>
          <ItemPlaceholder />
        </div>
      ) : (
        <span
          className={classNames({
            "before:p-2 before:text-gray-light1 before:animate-fade-in-ease before:content-['<'] text-xs":
              props.backArrowIcon,
          })}
        >
          <CtaLink
            itemScope
            itemType="https://schema.org/Thing"
            itemProp="item"
            styling="link"
            hasArrow={false}
            color="black"
            to={link}
            isBold={false}
          >
            {backIcon ? (
              <span className="text-xl mr-2 align-middle">←</span>
            ) : null}

            {loading ? (
              <ItemPlaceholder />
            ) : (
              <span
                itemProp="name"
                className="text-gray-light1 [a:hover_&]:text-brand [a:hover_&]:underline text-xs"
              >
                {props.label}
              </span>
            )}
          </CtaLink>
        </span>
      )}
      <meta itemProp="position" content={props.index + 1} />
    </li>
  );
};

BreadcrumbItem.propTypes = {
  loading: PropTypes.bool,
  link: PropTypes.string,
  label: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isLast: PropTypes.bool,
  backIcon: PropTypes.bool,
  backArrowIcon: PropTypes.bool,
};

export default BreadcrumbItem;
